// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__kpemE","inputDescription":"styles_inputDescription__3vckZ"};